<uni-snackbar [isNavigation]="false"></uni-snackbar>
<router-outlet></router-outlet>
